import { createContext } from 'react';

const mapContext = createContext();

export default mapContext;
